// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectedItem_wrapper__V241j","text":"SelectedItem_text__1G7LW"};